var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2955 5.2955C20.7348 4.85616 20.7348 4.14384 20.2955 3.7045C19.8562 3.26517 19.1438 3.26517 18.7045 3.7045L12 10.409L5.2955 3.7045C4.85616 3.26517 4.14385 3.26517 3.70451 3.7045C3.26517 4.14384 3.26517 4.85616 3.70451 5.2955L10.409 12L3.70451 18.7045C3.26517 19.1438 3.26516 19.8562 3.70451 20.2955C4.14384 20.7348 4.85616 20.7348 5.29549 20.2955L12 13.591L18.7045 20.2955C19.1438 20.7348 19.8562 20.7348 20.2955 20.2955C20.7348 19.8562 20.7348 19.1438 20.2955 18.7045L13.591 12L20.2955 5.2955Z",
    fill: "#7B868C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.bf0c476024b161bb95d6f7e745e93cdd.svg";
export { ForwardRef as ReactComponent };